import { render } from "./RequestPagesPage.vue?vue&type=template&id=532cdf84&ts=true"
import script from "./RequestPagesPage.vue?vue&type=script&lang=ts"
export * from "./RequestPagesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__